import { React, useEffect, useState } from "react";
import Chessground from "react-chessground";
import "react-chessground/dist/styles/chessground.css";
import "./Board.css";
import "./chessground.css";
import { useGlobalContext } from "../context";
import EvaluationBar from "./EvaluationBar";
import {
  fixBug,
  setChessboardColor,
} from "../helpers/chessboardHelperFunctions";

const Board = ({ chess, handleMove, calcMovable }) => {
  const {
    setPgn,
    fen,
    setFen,
    boardOrientation,
    showNotation,
    chessboardColor,
    showEvaluationBar,
    startPosition,
    setStartPosition,
    showBestMove,
    setShowBestMove,
    bestMoveCoords,
    size,
    setSize,
  } = useGlobalContext();

  useEffect(() => {
    if (
      startPosition !==
      "rnbqkbnr/pppppppp/8/8/8/8/PPPPPPPP/RNBQKBNR w KQkq - 0 1"
    ) {
      chess.reset();
      chess.load(startPosition);
      setFen(chess.fen());
      setStartPosition(
        "rnbqkbnr/pppppppp/8/8/8/8/PPPPPPPP/RNBQKBNR w KQkq - 0 1"
      );
    }
  }, []);

  useEffect(() => {
    setFen(chess.fen());
  });

  //fix bug from chessground library
  useEffect(() => {
    fixBug();
  });

  // reset chessboard
  useEffect(() => {
    chess.reset();
    setFen(chess.fen());
    setPgn(chess.pgn());
  }, [setFen, chess, setPgn]);

  // set chessboard color
  useEffect(() => {
    setChessboardColor(chessboardColor);
  }, [chessboardColor]);

  // show source and target square of the move
  const getLastMove = () => {
    const gameHistory = chess.history({ verbose: true });
    const sourceSquare =
      gameHistory.length && gameHistory[gameHistory.length - 1].from;
    const targetSquare =
      gameHistory.length && gameHistory[gameHistory.length - 1].to;

    return gameHistory.length ? [sourceSquare, targetSquare] : [];
  };

  // update board size
  useEffect(() => {
    const updateSize = () => {
      setShowBestMove(false);
      const newWidth = window.innerWidth;
      const newHeight = window.innerHeight;

      if (newWidth - 100 < 550) {
        setSize(newWidth - 150);
      } else {
        newHeight > 750 ? setSize(newHeight - 200) : setSize(550);
      }
    };
    window.addEventListener("resize", updateSize);

    return () => window.removeEventListener("resize", updateSize);
  });

  // turn to play (white, black)
  const turnColor = () => {
    return chess.turn() === "w" ? "white" : "black";
  };

  // show/hide notation
  useEffect(() => {
    const files = document.getElementsByClassName("files");
    const ranks = document.getElementsByClassName("ranks");
    if (!showNotation) {
      files[0].style.display = "none";
      ranks[0].style.display = "none";
    } else {
      files[0].style.display = "flex";
      ranks[0].style.display = "flex";
    }
  }, [showNotation, boardOrientation]);

  return (
    <>
      <div className="board-section">
        {showEvaluationBar && <EvaluationBar size={size} />}
        <div className="chessboard">
          <Chessground
            width={size}
            height={size}
            turnColor={turnColor()}
            onMove={handleMove}
            movable={calcMovable()}
            fen={fen}
            lastMove={getLastMove()}
            orientation={boardOrientation}
            animation={{ duration: 400 }}
          />
          {showBestMove ? (
            <div
              className="best-move-square"
              style={{
                width: `${size / 8}px`,
                height: `${size / 8}px`,
                transform: `translate(${bestMoveCoords.x}px, ${bestMoveCoords.y}px)`,
              }}
            ></div>
          ) : (
            <div></div>
          )}
        </div>
      </div>
    </>
  );
};

export default Board;
